import axios from '@/utils/request'
var Qs = require('qs')
export default {

  // 2020-08-01
  search(params) {
    return axios.get('/mes/workers', params)
  },
  // 2020-12-26
  trackingSearch(params) {
    return axios.get('/mes/workers/tracking?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },

  // 2020-12-23
  findByTenantId() {
    return axios.get('/mes/workers/find-by-tenant-id')
  },
  // 2020-12-27
  findByTenantIdWithInvalid() {
    return axios.get('/mes/workers/find-by-tenant-id-with-invalid')
  },
  // 2020-08-03
  findBySerialNo(params) {
    return axios.get('/mes/workers/find-by-serial-no', params)
  },
  // 2020-08-03
  create(params) {
    return axios.post('/mes/workers', params)
  },
  // 2020-08-03
  update(id, params) {
    return axios.put('/mes/workers/' + id, params)
  },
  // 2020-08-03
  delete(id) {
    return axios.delete('/mes/workers/' + id)
  },
  // 2020-08-03
  invalid(id) {
    return axios.put('/mes/workers/' + id + '/invalid')
  },
  // 2023-07-14
  recover(id) {
    return axios.put('/mes/workers/' + id + '/recover')
  },
  // 2021-03-22
  swapSequence(params) {
    return axios.put('/mes/workers/swap-sequence', params)
  },
  // 2020-12-24
  findByPhaseId(phaseId) {
    return axios.get('/mes/workers/find-by-phase-id/' + phaseId)
  },
  // 2021-08-04
  batchSetFacotry(params) {
    return axios.put('/mes/workers/batch-set-facotry', params)
  },
  // 2021-08-04
  findByUserFactory() {
    return axios.get('/mes/workers/find-by-user-factory')
  },
  // 2021-09-04
  exportExcel(params) {
    return axios.get('/mes/workers/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },

}

